<template>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Rekam Jejak</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Rekam Jejak Anda</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">
							<div class="card">
								<div class="card-body">
									
									<!-- Profile Settings Form -->
									<form>
										<div class="row form-row">
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Pendidikan Terakhir</label>
													<input type="text" class="form-control" value="">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Upload Foto Ijazah Anda disini (JPG maks 10 mb)</label>
													<input type="text" class="form-control" value="">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Sertifikat Penunjang (1) - Tuliskan sebagai apa</label>
													<input type="text" class="form-control" value="">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Upload Sertifikat Penunjang (1) (JPG maks 10 mb)</label>
													<input type="text" class="form-control" value="">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Sertifikat Penunjang (2) - Tuliskan sebagai apa</label>
													<input type="text" class="form-control" value="">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Upload Sertifikat Penunjang (2) (JPG maks 10 mb)</label>
													<input type="text" class="form-control" value="">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Sertifikat Penunjang (3) - Tuliskan sebagai apa</label>
													<input type="text" class="form-control" value="">
												</div>
											</div>
											<div class="col-12 col-md-6">
												<div class="form-group">
													<label>Upload Sertifikat Penunjang (3) (JPG maks 10 mb)</label>
													<input type="text" class="form-control" value="">
												</div>
											</div>
										</div>
										<div class="submit-section">
											<button type="submit" class="btn btn-primary submit-btn">Simpan Perubahan</button>
										</div>
									</form>
									<!-- /Profile Settings Form -->
									
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->
</template>

<script>
import Sidebar from '../Sidebar'
export default {
    components: {
        Sidebar
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Instructor/RekamJejak/index.vue